// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.unittypeselection {
      align-content: center;
}

.unittypeSelectioncontrol {
    width: 35px;
    height:100%;
}

.unitselection {
    /*margin-top: 8px;*/
    position:relative;
}

.unittypeSelectionButton {
    min-width: 2px;
    padding:0;
}



/*.valueSet input[type=number]::-webkit-inner-spin-button {
    margin-right: 20px;
}
.valueSet input[type=number]::-webkit-outer-spin-button {
    margin-right: 20px;
}*/
`, "",{"version":3,"sources":["webpack://./src/app/appbuilder/controls/unittypeselection/unitselection.theme.control.css"],"names":[],"mappings":"AAAA;MACM,qBAAqB;AAC3B;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,SAAS;AACb;;;;AAIA;;;;;EAKE","sourcesContent":[".unittypeselection {\n      align-content: center;\n}\n\n.unittypeSelectioncontrol {\n    width: 35px;\n    height:100%;\n}\n\n.unitselection {\n    /*margin-top: 8px;*/\n    position:relative;\n}\n\n.unittypeSelectionButton {\n    min-width: 2px;\n    padding:0;\n}\n\n\n\n/*.valueSet input[type=number]::-webkit-inner-spin-button {\n    margin-right: 20px;\n}\n.valueSet input[type=number]::-webkit-outer-spin-button {\n    margin-right: 20px;\n}*/\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
